const clubsSummary = (
  <div className="career-clubs-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">How Clubs Help Your Career</h3>
      <ul className="list-disc pl-6">
        <li>Clubs provide hands-on experience that strengthens your resume.</li>
        <li>
          They offer opportunities to work on projects, collaborate in teams, and build technical
          skills.
        </li>
        <li>
          Involvement in clubs can help you gain leadership experience and showcase initiative.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Types of Clubs and Their Benefits</h3>
      <ul className="list-disc pl-6">
        <li>
          <strong>Career-Oriented Clubs:</strong> These include organizations like Women in CS or
          the Society of Hispanic Professional Engineers, which host networking events and career
          panels.
        </li>
        <li>
          <strong>Activity-Based Clubs:</strong> These focus on hands-on projects. AI clubs work on
          machine learning models, game dev clubs design games, and hackathon clubs promote rapid
          software building.
        </li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">The Value of Leadership Roles</h3>
      <ul className="list-disc pl-6">
        <li>Leadership roles demonstrate strong management and teamwork skills to employers.</li>
        <li>
          Responsibilities may include organizing events, mentoring members, or leading technical
          projects.
        </li>
        <li>Holding a leadership position boosts your credibility and networking opportunities.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Networking Through Clubs</h3>
      <ul className="list-disc pl-6">
        <li>
          Clubs connect you with students, alumni, and recruiters, expanding your professional
          network.
        </li>
        <li>Many clubs have partnerships with companies, offering exclusive job opportunities.</li>
        <li>
          Attending club-hosted events can lead to mentorships, internships, and even full-time job
          offers.
        </li>
      </ul>
    </div>
  </div>
);

export default clubsSummary;
